import { render, staticRenderFns } from "./messagecenter.vue?vue&type=template&id=491913d4&"
import script from "./messagecenter.vue?vue&type=script&lang=js&"
export * from "./messagecenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports